export default __webpack_public_path__ + "img/fndcMVQw.753780e8.svg";